module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/nico-a409ac7c5aaa4c6f4a10b496e302ce8a.mp3";